import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AddAddressComponent} from '@app/shared/components/add-address/add-address.component';
import {MatDialog} from '@angular/material/dialog';
import {AddressService} from '@app/shared/services/address/address.service';
import {LoaderService} from '@app/core/services/loader/loader.service';
import {ErrorhandlerService} from '@app/shared/services/errorhandler/errorhandler.service';
import {NotificationService} from '@app/core/services/notification/notification.service';
import {GetAllAddressInteface} from '@app/shared/services/address/getAllAddress.inteface';
import { MaterialModule } from '@app/material/material.module';
import { AddressIconComponent } from '@app/shared/iconsvg/address-icon/address-icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.css']
})
export class AddressListComponent implements OnInit {

  addressList: GetAllAddressInteface[] = [];
  selectedAddressId: number;
  @Input() loginUserId: any;
  @Output() FetchAddress = new EventEmitter();

  constructor(private dialog: MatDialog,
              private addressService: AddressService,
              private loader: LoaderService,
              private errorhandlerService: ErrorhandlerService,
    private notificationService: NotificationService) {

  }

  ngOnInit() {
    this.fn_GetAllAddress();
  }

  /** function to open edit address dialog */
  fn_OpenEditAddressDialog(addressId: number) {
    const dialogRef = this.dialog.open(AddAddressComponent, {
      disableClose: true,
      width: '540px',
      data: {addressId}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.addressList = [];
      this.fn_GetAllAddress();
    });
  }

  /** function to delete the address from user profile addresses */
  fn_deleteAddress(addressId: number) {
    this.loader.show();
    this.addressService.deleteAddress(addressId, this.loginUserId).subscribe((res: any) => {
      this.loader.hide();
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Address');
        this.fn_GetAllAddress();
      }
    }, (err: any) => {
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
      this.loader.hide();
    });
  }

  /** Func called on select address radio button */
  fn_SelectAddress(addressid: number) {
    if(this.ValidateAddress(addressid)){
      // setting selected address for order placement
      var adrs = this.addressList.find(x=> x.AddressId == addressid);
      if(adrs){
        this.selectedAddressId = addressid;
        this.FetchAddress.emit(adrs);
      }
      else{      
        this.FetchAddress.emit(null);
      }
    }
    else{      
      this.FetchAddress.emit(null);
    }
  }

  ValidateAddress(addressId: number){
    if(this.addressList){
      var adrs = this.addressList.find(x=> x.AddressId == addressId);
      if(adrs){
        if(!adrs.Name){
          this.notificationService.error('Name should not be empty', 'Address');
          return false;
        }
        if(!adrs.AddressLine){
          this.notificationService.error('Address Line should not be empty', 'Address');
          return false;
        }
        if(!adrs.City){
          this.notificationService.error('City should not be empty', 'Address');
          return false;
        }
        if(!adrs.Country){
          this.notificationService.error('Country should not be empty', 'Address');
          return false;
        }
        if(!adrs.State){
          this.notificationService.error('State should not be empty', 'Address');
          return false;
        }
        if(!adrs.ZipCode){
          this.notificationService.error('Zip code should not be empty', 'Address');
          return false;
        }
        return true;
      }
    }
    return false;
  }

  fn_OpenAddAdressDialog(): void {
    const dialogRef = this.dialog.open(AddAddressComponent, {
      disableClose: true,
      width: '540px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.addressList = [];
      this.fn_GetAllAddress();
    });
  }

  /** Function to get all address */
  fn_GetAllAddress() {
    this.loader.show();
    this.addressService.getAllAddress(this.loginUserId).subscribe((res: any) => {
      this.loader.hide();
      if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
        this.addressList = res.Data.ResponseData;

        let exist = this.addressList.find(x=> x.AddressId == this.selectedAddressId);
        if(exist){
          this.fn_SelectAddress(this.selectedAddressId); 
        }
        else{          
          // setting selected address for order placement
          if(this.addressList && this.addressList.length){
            this.fn_SelectAddress(this.addressList[0].AddressId);   
          }  
          else{
            this.fn_SelectAddress(0);   
          }   
        }    
      } 
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }
}
